import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useUsersApiService } from '../../../../apis/users/useUsersApiService';
import {
  InternalUserParams,
  CreateInternalUserRequest,
  TInternalUserListApiResponse,
  UsersSummary,
} from '../../../../apis/users/users.api.interfaces';

export const INTERNAL_USERS_QUERY_KEY = 'internal-users';
export const INTERNAL_USERS_SUMMARY_QUERY_KEY = 'internal-users-summary';

export const useInternalUsersList = (
  params: InternalUserParams,
  enabled = true
) => {
  const { getInternalUsers } = useUsersApiService();
  return useQuery<TInternalUserListApiResponse>({
    queryKey: [INTERNAL_USERS_QUERY_KEY, params],
    queryFn: () => getInternalUsers(params),
    enabled,
  });
};

export const useCreateInternalUser = () => {
  const queryClient = useQueryClient();
  const { createInternalUser } = useUsersApiService();
  return useMutation({
    mutationFn: (data: CreateInternalUserRequest) => createInternalUser(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [INTERNAL_USERS_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [INTERNAL_USERS_SUMMARY_QUERY_KEY] });
    },
  });
};

export const useInternalUsersSummary = (enabled = true) => {
  const { getInternalUsersSummary } = useUsersApiService();
  return useQuery<UsersSummary>({
    queryKey: [INTERNAL_USERS_SUMMARY_QUERY_KEY],
    queryFn: () => getInternalUsersSummary(),
    enabled,
  });
};
